import React from 'react';
import cx from 'classnames';
import BeatLoader from '../../utils/spinner/BeatLoader';
import './FullscreenLoader.scss';

const FullscreenLoader = (props) => {
  const { visible, className, ...rest } = props;
  if (!visible) return null;

  return (
    <div className={cx('FullscreenLoader', className)} {...rest}>
      <BeatLoader isLoading={true} />
    </div>
  );
};

export default FullscreenLoader;
